import React, { useState, useEffect, useContext } from "react";
import { getHelp, setHelpAccessed } from "../services/dashApiService";
import { LoadingSpinner } from "./common/LoadingSpinner";
import { ModalDialog } from "./common/ModalDialog";
import { sanitize } from "dompurify";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";
import { XCircle } from "./common/IconsV2";
import { AccessibleFocusOutline } from "./common/AccessibleFocusOutline";

export const HelpPopup = ({
	show,
	onClose,
	helpCode,
	currentTheme,
	registration,
}) => {
	const [isLoading, setIsLoading] = useState();
	const [helpItemId, setHelpItemId] = useState(null);
	const [isAccessed, setIsAccessed] = useState(false);

	const [html, setHtml] = useState();
	const [title, setTitle] = useState(null);

	const [theme, setTheme] = useState(currentTheme);

	const context = useContext(DiseaseGroupContext);

	useEffect(() => {
		if (theme) {
		} else {
			setTheme(context.theme.primary());
		}
	}, []);

	useEffect(() => {
		let didCancel = false;

		setIsLoading(true);
		if (helpCode && helpCode.trim()) {
			getHelp(false, helpCode, registration)
				.then((result) => {
					if (!didCancel) {
						const data = result.data[0];
						setHtml({ __html: sanitize(data.text) });
						setIsLoading(false);
						setHelpItemId(data.id);
						setTitle(data.prompt);
					}
				})
				.catch(() => {
					if (!didCancel) {
						setHtml(getErrorHtml());
						setIsLoading(false);
					}
				});
		} else {
			setHtml(getErrorHtml());
			setIsLoading(false);
		}

		return () => {
			didCancel = true;
		};
	}, [helpCode, registration]);

	useEffect(() => {
		if (isAccessed === true && helpItemId) {
			setHelpAccessed(helpItemId)
				.then(() => {
					setIsAccessed(false);
				})
				.catch((error) => {
					console.error("Could not setHelpAccessed: ", error);
					setIsAccessed(false);
				});
		}
	}, [isAccessed, helpItemId]);

	useEffect(() => {
		if (show) {
			setIsAccessed(true);
		}
	}, [show]);

	const getErrorHtml = () => {
		return {
			__html: `
        <div>
          <h6 class="text-2xl mb-8 text-center">Sorry</h6>
          <p class="mb-3">We're unable to display any 'Help' right now.</p>
          <p class="mb-3">Please try again later.</p>
        </div>
      `,
		};
	};

	return (
		<ModalDialog show={show} onClose={onClose}>
			<div
				className={`relative bg-white flex flex-col text-black w-full h-full max-w-contentWrapper max-h-panel-lg shadow-lg overflow-hidden transition-all transform`}
			>
				<div className="flex justify-between items-center gap-4 sm:gap-5 p-3 sm:p-5">
					<h5 className="text-lg sm:text-xl font-bold block text-left sm:leading-5">
						{title}
					</h5>
					<AccessibleFocusOutline>
						<button onClick={onClose} className="flex items-center">
							<span className={"text-xs sm:text-sm mr-1.5"}>Close</span>
							<XCircle className={`w-6 sm:w-12 text-${theme?.group}-primary`} />
						</button>
					</AccessibleFocusOutline>
				</div>

				<div className={"flex-grow overflow-y-auto"}>
					{isLoading ? (
						<LoadingSpinner />
					) : (
						<div className={"m-4 mb-28"} dangerouslySetInnerHTML={html}></div>
					)}
				</div>

				<div className={"absolute left-0 right-0 bottom-0"}></div>
			</div>
		</ModalDialog>
	);
};
